/** Club 4X4 trusted windscreen partner (National Windscreen Group). */
export const TRUSTED_WINDSCREEN_REPAIRER_COMPANY = 'National Windscreen Group (NWG)' as const

/** Agent email “Choice of repairer” when the customer selects Club 4X4’s network (not “trusted insurer” wording). */
export const TRUSTED_WINDSCREEN_REPAIRER_CHOICE_LABEL = 'National Windscreen Group' as const

/** Repairer company label for review, email, and submit when the trusted network is chosen. */
export function trustedWindscreenRepairerCompanyLabel(
  storedCompany: string | null | undefined
): string {
  const trimmed = storedCompany?.trim()
  return trimmed || TRUSTED_WINDSCREEN_REPAIRER_COMPANY
}
